'use client'
import { RefObject, useRef } from 'react';


export function useSlideOverflowX<T extends HTMLElement>(ref: RefObject<T | null>) {
    const isMouseDown = useRef(false);
    const startX = useRef(0);
    const scrollLeft = useRef(0);
    const scrollSpeed = 2;

    const onMouseLeaving: React.MouseEventHandler<T> = (e) => {
        e.preventDefault();
        isMouseDown.current = false;
        if (!ref.current) return;
        ref.current.style.scrollSnapType = '';
        setPointerEventChildren('');
    };

    const onTouchEnd: React.TouchEventHandler<T> = (e) => {
        e.preventDefault();
        isMouseDown.current = false;
        if (!ref.current) return;
        ref.current.style.scrollSnapType = '';
        setPointerEventChildren('');
    };

    const setCurrentStart = (pageX: number) => {
        if (!ref.current) return;
        isMouseDown.current = true;
        startX.current = pageX - ref.current.offsetLeft;
        scrollLeft.current = ref.current.scrollLeft;
        ref.current.style.scrollSnapType = 'none';
    };

    const moveScroll = (pageX: number) => {
        if (!ref.current || !isMouseDown.current) return;
        ref.current.scrollLeft =
            scrollLeft.current -
            (pageX - ref.current.offsetLeft - startX.current) * scrollSpeed;
    };

    const onMouseMove: React.MouseEventHandler<T> = (e) => {
        e.preventDefault();
        moveScroll(e.pageX);
    };

    const onTouchMove: React.TouchEventHandler<T> = (e) => {
        moveScroll(e.touches[0].pageX);
    };

    const onMouseDown: React.MouseEventHandler<T> = (e) => {
        setCurrentStart(e.pageX);
        if (!ref.current) return;
    };

    const setPointerEventChildren = (value: string) => {
        if (!ref.current) return;
        const children = ref.current.children;
        if (!children.length) return;

        for (let i = 0; i < children.length; i++) {
            const item = children[i] as HTMLElement;
            item.style.pointerEvents = value;
        }
    };

    const onTouchStart: React.TouchEventHandler<T> = (e) => {
        setCurrentStart(e.touches[0].pageX);
    };
    return {
        onMouseLeaving,
        onTouchEnd,
        onMouseMove,
        onMouseDown,
        onTouchMove,
        onTouchStart,
    };
}